import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { isValidTagId } from '../../helpers/validate-helper';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-process.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { GridRemoteConstant } from '../../constants/grid-constant';
import { useStore } from '../../contexts/store-provider';
import {
  ProcessDefaultSortColumnOrder,
  ProcessFilterInitialState,
  TrayTagReassignFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { IProcessFilter } from '../../models/IProcessFilter';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  PlusIcon,
  RefreshIcon,
  TagReassignIcon,
  RightArrowMove,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
// import AddProcess from './components/add-edit-process';
// import AddProcessPopupHOC from './hoc/add-process-popup-hoc';
// import ProcessDetails from './process-details';
import TrayTagReassignmentDetails from './tray-tag-reassignment-details';
import AddCheckItemTemplatePopupHOC from './hoc/add-check-item-template-popup-hoc';
import './tray-tag-reassignment.css';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import Header from '../../shared-components/header/header';
import { Search } from 'react-bootstrap-icons';
import { ITrayTagReassignFilter } from '../../models/ITrayTagReassignFilter';
import config from '../../helpers/config-helper';

const appConfig = config();
const showAddTrayInput = appConfig.REACT_APP_SHOW_ADD_TRAY_INPUT;
const Process = (props: any) => {
  const { processStore, preferencesStore, tagReassignStore, operatorStore } =
    useStore();

  const {
    GetProcessListService,
    allProcess,
    processList,
    getAllProcessState,
    resetGetAllProcessState,
    TrayTagReassignService,
    trayTagReassignState,
    resetTrayTagReassignState,
  } = tagReassignStore;

  const { AssignTagService, assignTagState, resetAssignTagState } =
    operatorStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  let lang: string;
  const allProcessListData = allProcess;
  const [rows, setRows] = useState([]);
  const [manualTag, setManualTag] = useState('');
  const isFirstLoad = useRef(true);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [lastKeyTime, setLastKeyTime] = useState(Date.now());
  const [scanBuffer, setScanBuffer] = useState('');
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  // const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
  //   ProcessDefaultSortColumnOrder
  // );
  const [filterObj, setFilterObj] = useState<ITrayTagReassignFilter>(
    TrayTagReassignFilterInitialState
  );

  const [trayId, setTrayId] = useState('');
  const [isTrayIdApplied, setIsTrayIdApplied] = useState(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getProcessListServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        // Column: columSortOrder.dataField,
        // Order: columSortOrder.order,
      });
    }
    if (!isFilter) {
      GetProcessListService(
        Number(getTenantIdFromLocalStorage()),
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        trayId
        // encodeURIComponent(filterQuery)
      );
    } else {
      GetProcessListService(
        Number(getTenantIdFromLocalStorage()),
        1,
        pageLimitInfo.pageLimit,
        trayId
        // encodeURIComponent(filterQuery)
      );
    }
  };

  const handleTask = () => {
    if (selectedId === -1) return;

    const currentIndex = allProcess.findIndex((row) => row.Id === selectedId);
    if (currentIndex < allProcess.length - 1) {
      setSelectedId(allProcess[currentIndex + 1].Id);
      setSelectedRow(allProcess[currentIndex + 1]);
    }
  };

  useEffect(() => {
    getProcessListServiceHandler();
  }, []);

  useEffect(() => {
    setRows([...allProcess]);
    setSelectedRow(allProcess[0]);
    setSelectedId(allProcess[0]?.Id);
  }, [allProcess]);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: processList?.PagingDetails?.CurrentPage ?? 0,
      totalPages: processList?.PagingDetails?.TotalPages ?? 0,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [processList]);
  // useEffect(() => {
  //   setPageInfo({
  //     ...pageInfo,
  //     totalPages: processList?.PagingDetails?.TotalPages,
  //     isPagerChange: false,
  //   });
  //   setDisablePagination(false);
  // }, [processList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getProcessListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getProcessListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (trayTagReassignState.success) {
      toast.success(formatMessage('tag_assigned_successfully'));
      resetTrayTagReassignState();
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trayTagReassignState.success]);

  useEffect(() => {
    if (trayTagReassignState.error) {
      toast.error(formatMessage(trayTagReassignState.error));
      resetTrayTagReassignState();
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trayTagReassignState.error]);

  useEffect(() => {
    if (getAllProcessState.success) {
      resetGetAllProcessState();
    }
  }, [getAllProcessState.success]);

  useEffect(() => {
    if (!selectedRow) return;
    const handleKeyDown = (e) => {
      if (!e.key) return;
      const currentTime = Date.now();
      const timeDiff = currentTime - lastKeyTime;
      // If key delay is too long, treat it as a new scan
      //ARIF: WHY?? DOES SCAN NEED THIS?? TEST WITHOUT THIS WITH SCANNER
      if (e.target?.tagName === 'INPUT' || e.target?.tagName === 'BUTTON') {
        setScanBuffer(() => '');
      } else {
        if (timeDiff > 100) {
          setScanBuffer(() => e.key);
        } else {
          setScanBuffer((prev) => prev + e.key);
        }
      }
      setLastKeyTime(currentTime);

      if (e.key === 'Enter') {
        const stringsToReplace = ['Shift', 'CapsLock', 'Tab'];
        const cleanedScan = scanBuffer.replace(
          new RegExp(stringsToReplace.join('|'), 'g'),
          ''
        );
        if (isValidTagId(cleanedScan)) {
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.Id === selectedId
                ? { ...row, ScannedTagId: cleanedScan }
                : row
            )
          );
        }
        setScanBuffer('');
        handleTask();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedRow, scanBuffer, lastKeyTime]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    setSelectedRow(row);
    setSelectedId(row.Id);
    setManualTag(row.TagId || '');
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    getProcessListServiceHandler();
    closePanelHandler();
  };

  const openAddProcessHandler = (
    row: { Id: number; TagId?: string },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event?.stopPropagation();

    const currentRow = rows.find((r) => r.Id === row.Id);
    const tagToAssign = currentRow?.ScannedTagId?.trim();

    if (!isValidTagId(tagToAssign)) {
      toast.error(formatMessage('enter_valid_tag_id'));
      return;
    }

    TrayTagReassignService({
      TenantId: Number(getTenantIdFromLocalStorage()),
      TagTrays: [
        {
          TrayId: currentRow.TrayId,
          TagId: tagToAssign,
          OldTagId: currentRow.TagId,
        },
      ],
      IsTagReassigned: true,
    });
  };

  const createQueryString = (filter: ITrayTagReassignFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: ITrayTagReassignFilter) => {
    const filters = {
      ...object,
      // Column: columSortOrder.dataField,
      // Order: columSortOrder.order,
    };
    const filter = createQueryString({ ...filters });
    getProcessListServiceHandler(filter, true);
    setFilterObj({ ...filters });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const filterParams = (
    obj: ITrayTagReassignFilter,
    isfilterCleard: boolean
  ) => {
    const filter = createQueryString({
      ...obj,
      // Column: columSortOrder.dataField,
      // Order: columSortOrder.order,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      getProcessListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const handleTableChange = (type: any, newState: any) => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    // setColumnSortOrder((prevState) => ({
    //   ...prevState,
    //   dataField: newState.sortField,
    //   order: newState.sortOrder,
    // }));
  };

  // useEffect(() => {
  //   const filter = createQueryString({
  //     ...filterObj,
  //     // Column: columSortOrder.dataField,
  //     // Order: columSortOrder.order,
  //   });

  //   getProcessListServiceHandler(filter);
  // }, [columSortOrder]);

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isEdit',
        handler: openAddProcessHandler,
        icon: <TagReassignIcon />,
        // isDisable: !isOperationPermittedRoleBase(
        //   ModuleType.ProcessManagement,
        //   'Edit'
        // ),
        isDisable: false,
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
    ],
    ModuleType.TrayTagReassignment
  );

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'Id',
      text: formatMessage('label_id'),
      classes: 'show-Elipses',
      hidden: true,
    },
    {
      dataField: 'TrayId',
      text: formatMessage('tray_id'),
      classes: 'show-Elipses',
      // title: (cell: string) => {
      //   return cell.length > 10 ? cell : undefined;
      // },
      // sort: true,
    },
    {
      dataField: 'TagId',
      text: formatMessage('tag_id'),
      // sort: true,
      classes: 'show-Elipses',
      // title: (cell: string) => {
      //   return cell.length > 10 ? cell : undefined;
      // },
    },
    {
      dataField: 'ScannedTagId',
      text: formatMessage('scanned_tag_id'),
      // sort: true,
      classes: 'show-Elipses',
      // title: (cell: string) => {
      //   return cell.length > 10 ? cell : undefined;
      // },
    },
    {
      dataField: 'ProcessName',
      text: formatMessage('process'),
      classes: 'show-Elipses',
      // title: (cell: string) => {
      //   return cell.length > 10 ? cell : undefined;
      // },
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];

  const selectRow = {
    mode: 'radio',
    clickToSelect: true,
    selected: selectedId ? [selectedId] : [],
    onSelect: (row, isSelect) => {
      if (!isSelect) {
        return false;
      }
      setSelectedId(row.Id);
      setSelectedRow(row);
    },
    // nonSelectable: rows.map((row) => row.Id),
    hideSelectAll: true,
    selectionRenderer: ({ checked }) => {
      return checked && <RightArrowMove />;
    },
  };

  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col"
            label="tray_tag_reassignment_title"
          />
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="add-list">
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              <li className="d-flex">
                <div className="mx-2 search-id-prod">
                  <div
                    className=""
                    style={{
                      position: 'relative',
                    }}
                  >
                    <input
                      className="form-control"
                      type="text"
                      value={trayId}
                      placeholder={formatMessage('tray_id')}
                      onChange={(e) => {
                        // const value = e.target.value.replace(/\D/g, ''); // remove non-numeric characters
                        const value = e.target.value.replace(/[^0-9-]/g, '');
                        setTrayId(value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          if (trayId && trayId.length > 0) {
                            setFilterObj(() => ({
                              ...filterObj,
                              TrayId: trayId,
                            }));
                            GetProcessListService(
                              Number(getTenantIdFromLocalStorage()),
                              pageInfo.currentPage,
                              pageLimitInfo.pageLimit,
                              trayId
                            );
                            setIsTrayIdApplied(true);
                          } else {
                            setIsTrayIdApplied(false);
                            setFilterObj(() => ({
                              ...filterObj,
                              TrayId: '',
                            }));
                            GetProcessListService(
                              Number(getTenantIdFromLocalStorage()),
                              pageInfo.currentPage,
                              pageLimitInfo.pageLimit,
                              trayId
                            );
                            setTrayId('');
                          }
                        }
                      }}
                    />{' '}
                    <button
                      type="button"
                      onClick={() => {
                        if (trayId && trayId.length > 0) {
                          setFilterObj(() => ({
                            ...filterObj,
                            TrayId: trayId,
                          }));
                          GetProcessListService(
                            Number(getTenantIdFromLocalStorage()),
                            pageInfo.currentPage,
                            pageLimitInfo.pageLimit,
                            trayId
                          );
                          setIsTrayIdApplied(true);
                        }
                      }}
                      className={`btn btn-sm ${isTrayIdApplied ? 'remove-btn-product-search' : 'remove-btn-product-search-fix '}`}
                    >
                      <Search />
                    </button>
                    {isTrayIdApplied && (
                      <button
                        type="button"
                        onClick={() => {
                          setIsTrayIdApplied(false);
                          setFilterObj(() => ({
                            ...filterObj,
                            TrayId: '',
                          }));
                          setTrayId('');
                          GetProcessListService(
                            Number(getTenantIdFromLocalStorage()),
                            pageInfo.currentPage,
                            pageLimitInfo.pageLimit,
                            ''
                          );
                        }}
                        className="btn btn-danger btn-sm remove-btn-product"
                      >
                        &times;
                      </button>
                    )}
                  </div>
                </div>
              </li>

              {showAddTrayInput && (
                <li className="d-flex align-items-center">
                  <div className="mx-2">
                    <input
                      className="form-control"
                      type="text"
                      value={manualTag}
                      placeholder={formatMessage('tag_id')}
                      onChange={(e) => {
                        const val = e.target.value;
                        setManualTag(val);
                        if (selectedId !== 0) {
                          setRows((prevRows) =>
                            prevRows.map((row) =>
                              row.Id === selectedId
                                ? { ...row, ScannedTagId: val }
                                : row
                            )
                          );
                        }
                      }}
                    />
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllProcessState.inProgress ||
            trayTagReassignState.inProgress) && (
            <FormLoader
              loading={
                getAllProcessState.inProgress || trayTagReassignState.inProgress
              }
            />
          )}
          {allProcessListData && allProcessListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {rows && (
                      <Grid
                        data={rows}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        // sort={{ ...columSortOrder }}
                        remote={{ ...GridRemoteConstant }}
                        onTableChange={handleTableChange}
                        selectRow={selectRow}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allProcessListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={
                        processList?.PagingDetails?.TotalRecords ?? 0
                      }
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_tray_tag" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_tray_tag_message')}
                  </h4>
                  {/* {isOperationPermittedRoleBase(
                    ModuleType.ProcessManagement,
                    'Add'
                  ) && (
                    <>
                      <a
                        className="btn btn-primary"
                        onClick={(event: any) =>
                          openAddProcessHandler({ Id: -1 }, event)
                        }
                      >
                        <span className="me-1">
                          <PlusIcon />{' '}
                        </span>
                        <FormattedMessage id="add_process" />
                      </a>
                    </>
                  )} */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FilterPopupHOC(
  AddCheckItemTemplatePopupHOC(DeletePopupHOC(observer(Process)))
);
